import React from "react";
import { OutlinedButton } from "../../../../../components/form-controls/button/outlined-button/outlined-button.component";
import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";
import { FileDownloadButtonProps } from "./file-download-button.props";

export const FileDownloadButton = withShowIf((props: FileDownloadButtonProps) => (
  <OutlinedButton variant={"outlined"} startIcon={props.icon} onClick={props.onDownload}>
    {props.children}
  </OutlinedButton>
));
